export class GalleryTitleStyle {
  size = '';
  decoration = '';
  decorationColor = '';
  font = 'tb-font-primary';
  color = 'uk-color-black';
  marginTop = 'uk-margin-top';
  transition = '';
  subtitleAlignment = '';

  static normalize(styles: Partial<GalleryTitleStyle>): GalleryTitleStyle {
    const pureStyles = new GalleryTitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;
    pureStyles.transition = styles.transition ?? pureStyles.transition;
    pureStyles.subtitleAlignment = styles.subtitleAlignment ?? pureStyles.subtitleAlignment;

    return pureStyles;
  }
}
